import { LabelQuestionConfig, LabelResponseState } from '@gripp/shared-logic';
import { RoutineQuestionModule } from '../types';
import { LabelQuestionAdminForm } from './labelQuestionAdminForm';
import { LabelQuestionMessage } from './labelQuestionMessage';
import { LabelQuestionExecutionForm } from './labelQuestionExecutionForm';

export const LabelQuestionModule: RoutineQuestionModule<
  LabelQuestionConfig,
  LabelResponseState
> = {
  adminForm: LabelQuestionAdminForm,
  executionForm: LabelQuestionExecutionForm,
  message: LabelQuestionMessage,
};
